class DateLocalizer {
  constructor(date) {
    this.date = new Date(date);
  }

  toDate() {
    return this.date.toLocaleDateString();
  }

  toDateTime() {
    return this.date.toLocaleString();
  }

  toTime() {
    return this.date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  toTimeInZone(timeZone) {
    return this.date.toLocaleTimeString(undefined, {
      timeZone,
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}

export default DateLocalizer;



// WEBPACK FOOTER //
// ./src/utils/DateLocalizer.js